import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useUploadScans = () => {
  return useMutation({
    mutationFn: (data) => api.scans.uploadItem(data),
    onError: (error) => {
      toaster.create({
        title: 'Не удалось загрузить данные',
        description: error?.message,
        type: 'error',
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Фотография успешно добавлена',
        type: 'success',
      })
    }
  })
}
